module.exports = __webpack_public_path__ + "img/stackoverflow.dc44b719.svg";